import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export function touchAll(formGroup: UntypedFormGroup | UntypedFormArray) {
  if (formGroup instanceof UntypedFormGroup) {
    Object.values(formGroup.controls).forEach((control: AbstractControl) => {
      touchControl(control);

      // for use with libs/ui/src/lib/section-value-accessor/section-value-accessor.ts
      // and libs/ui/src/lib/section-value-accessor/section-validator.ts
      if (control instanceof AbstractControl && (<any>control).sectionForm) {
        // must access the control with with <any>, control.get('sectionForm') does not work here
        // because it's custom added to the control object by _setValidators() in our SectionValueAccessor
        const sectionForm = (<any>control)['sectionForm'] as UntypedFormGroup;
        touchAll(sectionForm);
        control.updateValueAndValidity();
      }
    });
  }

  if (formGroup instanceof UntypedFormArray) {
    formGroup.controls.forEach((control: AbstractControl) => {
      touchControl(control);
    });
  }
}

function touchControl(control: AbstractControl) {
  if (control instanceof AbstractControl) control.markAsTouched();
  if (control instanceof UntypedFormGroup) touchAll(control as UntypedFormGroup);
  if (control instanceof UntypedFormArray) touchAll(control as UntypedFormArray);
}
